package app.nestbridge.domain.identity.api

import app.nestbridge.app.di.ClientApiConfig
import app.nestbridge.domain.identity.api.model.UserProfileDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class RemoteUserProfileApiClient(
    private val httpClient: HttpClient,
    private val config: ClientApiConfig,
) : UserProfileApiClient {

    private val baseUrl get() = "${config.identityServiceUrl}/user/me/profile"

    override suspend fun fetchCurrent(): UserProfileDto? {
        val response: HttpResponse = httpClient.get(baseUrl)
        return when (response.status) {
            HttpStatusCode.OK -> response.body()
            HttpStatusCode.NotFound -> null
            else -> error("Unexpected response fetching user profile: ${response.status}")
        }
    }

    override suspend fun save(profile: UserProfileDto): UserProfileDto {
        // POST to create (blank id), PUT to update
        val response = if (profile.id.isBlank()) {
            httpClient.post(baseUrl) {
                contentType(ContentType.Application.Json)
                setBody(profile)
            }
        } else {
            httpClient.put(baseUrl) {
                contentType(ContentType.Application.Json)
                setBody(profile)
            }
        }
        return response.body()
    }
}
